import { render, staticRenderFns } from "./ExportDropdown.vue?vue&type=template&id=0047b4ef&scoped=true&lang=html&"
import script from "./ExportDropdown.vue?vue&type=script&lang=js&"
export * from "./ExportDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0047b4ef",
  null
  
)

export default component.exports